import FormattedMessage from 'I18n/components/FormattedMessage';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url';
import { Button } from 'foundations-components/transitional/components/Button';
import { getAcademyTrialRedirectLink } from '../../../../trial/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialRedirectButton = ({
  buttonText,
  onClick = () => {},
  block = true,
  use = 'primary',
  upgradeData: {
    app,
    upgradeProduct
  }
}) => {
  const isLearningCenter = app === 'learning-center';
  const handleClick = () => {
    if (isLearningCenter) {
      // replace with getAcademyTrialRedirectLinkFromApiName when trialGuide supports apiNames
      openNewTab(getAcademyTrialRedirectLink(upgradeProduct));
    }
    onClick();
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: handleClick,
    external: isLearningCenter ? true : undefined,
    href: isLearningCenter ? getAcademyTrialRedirectLink(upgradeProduct) : undefined,
    block: block,
    use: use,
    children: buttonText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.activationModal.getStarted"
    })
  });
};
export default TrialRedirectButton;